if (!customElements.get('tj-park-passport')) customElements.define('tj-park-passport', class extends HTMLElement {
  connectedCallback() {
    this.buttons = [...this.querySelectorAll('[role="radio"]')];
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.buttons.forEach((button, index) => {
      button.addEventListener('click', () => this.select(index), options);
      button.addEventListener('keydown', (event) => {
        const offsets = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
        let next = index;
        if (event.key in offsets) next = (index + offsets[event.key] + this.buttons.length) % this.buttons.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this.buttons.length - 1;
        else return;
        event.preventDefault();
        this.select(next);
        this.buttons[next].focus();
      }, options);
    });
    this.select(Math.max(0, this.buttons.findIndex(button => button.dataset.name === this.dataset.default)));
    this.querySelector('form')?.addEventListener('submit', () => {
      const button = this.querySelector('[name="add"]');
      button.setAttribute('aria-busy', 'true');
      button.querySelector('span').textContent = this.dataset.adding;
    }, options);
    const submit = this.querySelector('[name="add"]');
    if (submit) {
      this.observer = new MutationObserver(() => {
        if (!submit.classList.contains('loading') && submit.hasAttribute('aria-busy')) {
          submit.removeAttribute('aria-busy');
          submit.querySelector('span').textContent = this.current.dataset.available === 'true' ? this.dataset.add : this.dataset.sold;
        }
      });
      this.observer.observe(submit, { attributes: true, attributeFilter: ['class'] });
    }
  }
  disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
  select(index) {
    const selected = this.buttons[index];
    if (!selected || this.querySelector('[name="add"]')?.classList.contains('loading')) return;
    this.current = selected;
    this.buttons.forEach(button => { button.setAttribute('aria-checked', String(button === selected)); button.tabIndex = button === selected ? 0 : -1; });
    this.querySelector('[data-park-name]').textContent = selected.dataset.name;
    this.querySelector('[data-park-price]').textContent = selected.dataset.price;
    this.querySelector('[data-park-status]').textContent = this.dataset.selected.replace('[park]', selected.dataset.name);
    const area = this.querySelector('.tj-passport-image');
    let image = area.querySelector('img');
    if (selected.dataset.image) {
      if (!image) { image = document.createElement('img'); image.className = 'tj-park-image'; area.append(image); }
      image.srcset = selected.dataset.srcset;
      image.sizes = '(min-width: 990px) 40vw, 100vw';
      image.src = selected.dataset.image;
      image.alt = selected.dataset.name;
      image.hidden = false;
    } else if (image) image.hidden = true;
    const id = this.querySelector('[name="id"]');
    if (id) { id.value = selected.dataset.id; id.disabled = false; }
    const button = this.querySelector('[name="add"]');
    if (button) {
      button.disabled = selected.dataset.available !== 'true';
      button.removeAttribute('aria-disabled');
      button.querySelector('span').textContent = button.disabled ? this.dataset.sold : this.dataset.add;
      this.querySelector('product-form')?.handleErrorMessage(false);
    }
  }
});
